import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout for /settings/groups and its child routes. TanStack Router parents
 * any `groups.$id...` sibling file under this one whenever `groups.tsx`
 * exists, so this must render an `<Outlet />` for the group list
 * (`groups.index.tsx`) and the group's تعيين الخدمات page
 * (`groups.$id.tsx`) to actually appear.
 */
export const Route = createFileRoute('/_app/settings/groups')({
  component: () => <Outlet />,
});
